/* Lock only the mobile navigation; leave Shopify's cart/filter/zoom dialogs alone. */
(()=>{
  const init=()=>{
    const menus=[...document.querySelectorAll('.mobile-menu,.mgh-mobile-menu')];
    const media=matchMedia('(max-width:1100px)');let active=null,saved=null;
    function release(){if(!saved)return;const y=saved.y;for(const [key,value] of Object.entries(saved.styles))document.body.style[key]=value;document.documentElement.style.removeProperty('--mirage-mobile-nav-top');saved=null;active=null;window.scrollTo({top:y,behavior:'instant'});}
    function close(){if(active)active.open=false;release();}
    menus.forEach(menu=>menu.addEventListener('toggle',()=>{
      if(!menu.open){if(active===menu)release();return;}
      if(!media.matches)return;
      if(active&&active!==menu)close();active=menu;
      const header=menu.closest('.site-header,.mgh-header');
      const top=Math.max(0,Math.min(innerHeight-100,header.getBoundingClientRect().bottom));
      document.documentElement.style.setProperty('--mirage-mobile-nav-top',`${top}px`);
      const keys=['position','top','left','right','width'];saved={y:scrollY,styles:Object.fromEntries(keys.map(k=>[k,document.body.style[k]]))};
      Object.assign(document.body.style,{position:'fixed',top:`-${saved.y}px`,left:'0',right:'0',width:'100%'});
    }));
    document.addEventListener('keydown',e=>{if(!active)return;if(e.key==='Escape'){const s=active.querySelector(':scope>summary');close();s.focus();return;}if(e.key!=='Tab')return;
      const items=[...active.querySelectorAll('summary,a[href],button,input,select')].filter(el=>el.getClientRects().length&&getComputedStyle(el).visibility!=='hidden');const first=items[0],last=items.at(-1);if(e.shiftKey&&document.activeElement===first){e.preventDefault();last?.focus();}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first?.focus();}
    });
    document.addEventListener('pointerdown',e=>{if(active&&!active.contains(e.target))close();});
    media.addEventListener('change',()=>{if(!media.matches)close();});
    window.addEventListener('pagehide',close);
    // The theme's mobile Apply button only closed the drawer. Keep edits as
    // drafts, then submit Shopify's actual filter values together on Apply.
    const phoneFilters=matchMedia('(max-width:768px)');
    const filterForm=target=>target.closest?.('#filterCollectionProductDrawer form.filter-form');
    document.addEventListener('input',e=>{if(phoneFilters.matches&&filterForm(e.target))e.stopImmediatePropagation();},true);
    document.addEventListener('change',e=>{if(phoneFilters.matches&&filterForm(e.target)&&e.target.name==='sort_by')e.stopImmediatePropagation();},true);
    document.addEventListener('click',e=>{
      if(!phoneFilters.matches)return;
      const apply=e.target.closest('.js-collection-product-done-btn');
      const reset=e.target.closest('#filterCollectionProductDrawer .js-collection-product-clear-all-btn');
      if(!apply&&!reset)return;
      const form=document.querySelector('#filterCollectionProductDrawer form.filter-form');if(!form)return;
      e.preventDefault();e.stopImmediatePropagation();
      const url=new URL(location.href);for(const key of [...url.searchParams.keys()])if(key.startsWith('filter.')||key==='page')url.searchParams.delete(key);
      if(apply)for(const [key,value] of new FormData(form)){if(!String(value).trim())continue;if(key==='sort_by')url.searchParams.set(key,value);else if(key.startsWith('filter.'))url.searchParams.append(key,value);}
      url.hash='';location.assign(url.toString());
    },true);
  };document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init):init();
})();

/* Product galleries keep their selected media when a phone rotates. Native
 * theme thumbnail code switches at 769px and rebinds handlers on every resize;
 * keep that legacy behavior out of this compact gallery only. */
(()=>{
  const compact=matchMedia('(max-width:1024px)'),states=new WeakMap(),thumbs=new WeakSet();
  const motion=()=>matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth';
  function mark(track,item){
    if(!item)return;
    const state=states.get(track);if(state)state.id=item.dataset.mediaId;
    track.closest('sht-prd-slideshow')?.querySelectorAll('.js-product-slideshow-thumb').forEach(t=>t.classList.toggle('is-active-item',t.dataset.mediaTargetId===item.dataset.mediaId));
  }
  function jump(track,item,behavior='auto'){
    if(!item)return;mark(track,item);
    track.scrollTo({left:item.offsetLeft,top:0,behavior});
  }
  function setup(){
    document.querySelectorAll('.main-product .mirage-product-description-details').forEach(details=>{
      const area=details.querySelector('.js-expandable-content')||details.querySelector(':scope > .rte');
      if(area){area.classList.add('mirage-description-scroll');area.tabIndex=0;area.setAttribute('role','region');area.setAttribute('aria-label','Product description');}
    });
    document.querySelectorAll('.main-product sht-vert-carousel').forEach(t=>{
      if(thumbs.has(t))return;thumbs.add(t);
      // Thumbnail controls are handled once below; desktop thumbnails are hidden.
      t.transform=()=>{};t.setActiveMedia=()=>{};t.horizontalSetActiveMedia=()=>{};
      const refresh=()=>{if(compact.matches&&t.isConnected&&t.container&&t.horizontalInit)t.horizontalInit();};
      t.init=refresh;t.updateCarousel=()=>{if(compact.matches&&t.itemsToShow?.length>1)t.horizontalUpdateCarousel();};
      t.bindEventHandlers=()=>{};t.horizontalBindEventHandlers=()=>{};
      t.container?.addEventListener('scroll',refresh,{passive:true});setTimeout(refresh,350);
    });
    document.querySelectorAll('.main-product .product-slideshow__items').forEach(track=>{
      if(states.has(track))return;
      const state={id:track.firstElementChild?.dataset.mediaId,resizing:false,timer:0};states.set(track,state);
      track.addEventListener('scroll',()=>{
        if(!compact.matches||state.resizing)return;
        clearTimeout(state.timer);state.timer=setTimeout(()=>{
          if(state.resizing)return;
          const item=[...track.children].reduce((best,item)=>!best||Math.abs(item.offsetLeft-track.scrollLeft)<Math.abs(best.offsetLeft-track.scrollLeft)?item:best,null);
          mark(track,item);
        },100);
      },{passive:true});
    });
  }
  let timer;
  function resize(){
    document.querySelectorAll('.main-product .product-slideshow__items').forEach(t=>{const s=states.get(t);if(s){s.resizing=true;clearTimeout(s.timer);}});
    clearTimeout(timer);timer=setTimeout(()=>{
      setup();document.querySelectorAll('.main-product sht-vert-carousel').forEach(t=>t.init?.());document.querySelectorAll('.main-product .product-slideshow__items').forEach(track=>{
        const s=states.get(track);if(!s)return;
        if(compact.matches){
          const item=[...track.children].find(i=>i.dataset.mediaId===s.id)||track.firstElementChild;
          jump(track,item);const carousel=track.closest('sht-carousel');if(carousel?.init)carousel.init();
        }else{track.scrollLeft=0;}
        requestAnimationFrame(()=>{s.resizing=false;});
      });
    },300);
  }
  document.addEventListener('click',event=>{
    if(!compact.matches)return;
    const root=event.target.closest('.main-product sht-prd-slideshow');if(!root)return;
    const track=root.querySelector('.product-slideshow__items');if(!track)return;
    const thumb=event.target.closest('.js-slideshow-btn-thumb');
    const arrow=event.target.closest('.js-carousel-prev-btn,.js-carousel-next-btn');
    if(!thumb&&!arrow)return;
    event.preventDefault();event.stopImmediatePropagation();
    if(thumb){jump(track,[...track.children].find(i=>i.dataset.mediaId===thumb.dataset.target),motion());return;}
    const strip=arrow.closest('sht-vert-carousel')?.querySelector('.js-carousel-items');
    if(strip){strip.scrollBy({left:(arrow.name==='next'?1:-1)*strip.clientWidth*.75,behavior:motion()});return;}
    const items=[...track.children],index=Math.round(track.scrollLeft/track.clientWidth),next=Math.max(0,Math.min(items.length-1,index+(arrow.name==='next'?1:-1)));
    jump(track,items[next],motion());
  },true);
  const init=()=>{setup();const root=document.querySelector('.main-product');if(root)new MutationObserver(setup).observe(root,{childList:true,subtree:true});};
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init):init();
  window.addEventListener('resize',resize,{passive:true});window.addEventListener('orientationchange',resize,{passive:true});
})();
